import { NgModule } from "@angular/core";
import { SamplesComponent } from "./samples.component";
import { RouterModule } from "@angular/router";

@NgModule({
  declarations: [
    SamplesComponent,
  ],
  exports: [
    SamplesComponent,
  ],
  imports: [
    RouterModule,
  ],
})
export class SamplesModule {
}
